import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ShoppingCart, Menu, X, Search } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { Brand, BRAND_NAME } from './Brand';

const navLinks = [
  { name: 'Početna', path: '/', id: 'home' },
  { name: 'O nama', path: '/o-nama', id: 'about' },
  { name: 'WebShop', path: '/webshop', id: 'webshop' },
  { name: 'Katalozi', path: '/katalozi', id: 'catalogs' },
  { name: 'Kontakt', path: '/kontakt', id: 'contact' }
];

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { getCartCount } = useCart();
  const location = useLocation();
  const cartCount = getCartCount();

  useEffect(() => { setIsOpen(false); }, [location.pathname]);

  return (
    <nav className="brand-header sticky top-0 z-50" aria-label="Glavna navigacija" data-testid="main-navigation">
      <div className="premium-container">
        <div className="brand-header-row">
          <Link to="/" className="brand-home-link" aria-label={`${BRAND_NAME} — početna`} data-testid="navbar-home-logo-link">
            <Brand placement="navbar" />
          </Link>
          <div className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.id}
                to={link.path}
                className="brand-nav-link"
                aria-current={location.pathname === link.path ? 'page' : undefined}
                data-testid={`desktop-nav-${link.id}`}
              >
                {link.name}
              </Link>
            ))}
          </div>
          <div className="flex items-center gap-1 sm:gap-3 shrink-0">
            <Link to="/webshop" className="brand-icon-button brand-search-link" aria-label="Pretražite rasvjetu" data-testid="navbar-search-link"><Search size={19} /></Link>
            <Link to="/cart" className="brand-icon-button relative" aria-label={`Košarica (${cartCount})`} data-testid="navbar-cart-link">
              <ShoppingCart className="w-5 h-5" aria-hidden="true" />
              {cartCount > 0 && (
                <span className="brand-cart-count" data-testid="navbar-cart-count">{cartCount}</span>
              )}
            </Link>
            <button
              type="button"
              onClick={() => setIsOpen(!isOpen)}
              onKeyDown={(event) => { if (event.key === 'Escape') setIsOpen(false); }}
              className="brand-icon-button lg:hidden"
              aria-label={isOpen ? 'Zatvori izbornik' : 'Otvori izbornik'}
              aria-expanded={isOpen}
              aria-controls="mobile-navigation"
              data-testid="mobile-menu-toggle"
            >
              {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>
        {isOpen && (
          <div id="mobile-navigation" className="brand-mobile-menu lg:hidden" data-testid="mobile-navigation-menu">
            {navLinks.map((link) => (
              <Link
                key={link.id}
                to={link.path}
                className="brand-nav-link block py-3"
                aria-current={location.pathname === link.path ? 'page' : undefined}
                data-testid={`mobile-nav-${link.id}`}
              >
                {link.name}
              </Link>
            ))}
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;